import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, Observable, of, tap } from 'rxjs';
import { SeasonFilterOptions } from '@gbr-monorepo/interfaces';
import { SeasonService } from '../../services/season.service';
import { LoadApplicationsFilterOptions, ResetApplicationsFilterOptions } from './applications-filter.action';

export interface ApplicationsFilterStateModel {
    payoutPeriods: string[];
    isLoadingOptions: boolean;
}

const INITIAL_STATE: ApplicationsFilterStateModel = {
    payoutPeriods: [],
    isLoadingOptions: false
};

@State<ApplicationsFilterStateModel>({
    name: 'applicationsFilter',
    defaults: INITIAL_STATE
})
@Injectable()
export class ApplicationsFilterState {
    private readonly seasonService = inject(SeasonService);

    @Selector()
    static getPayoutPeriodOptions(state: ApplicationsFilterStateModel): string[] {
        return state.payoutPeriods;
    }

    @Selector()
    static isLoadingOptions(state: ApplicationsFilterStateModel): boolean {
        return state.isLoadingOptions;
    }

    @Action(LoadApplicationsFilterOptions)
    loadApplicationsFilterOptions(
        ctx: StateContext<ApplicationsFilterStateModel>,
        action: LoadApplicationsFilterOptions
    ): Observable<SeasonFilterOptions> {
        ctx.patchState({ isLoadingOptions: true });

        return this.seasonService.getApplicationFilterOptions(action.payload.seasonId).pipe(
            tap(options =>
                ctx.patchState({
                    payoutPeriods: options.payoutPeriods,
                    isLoadingOptions: false
                })
            ),
            catchError(() => {
                ctx.patchState({ payoutPeriods: [], isLoadingOptions: false });
                return of(void 0);
            })
        );
    }

    @Action(ResetApplicationsFilterOptions)
    resetApplicationsFilterOptions(ctx: StateContext<ApplicationsFilterStateModel>): void {
        ctx.setState(INITIAL_STATE);
    }
}
